/**
 * @generated SignedSource<<e53122b13ac4ff1c068cea17a4365d60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteAutojoinDomainInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteAutojoinDomainMutation$variables = {
  input: DeleteAutojoinDomainInput;
};
export type deleteAutojoinDomainMutation$data = {
  readonly deleteAutojoinDomain: {
    readonly deletedAutojoinDomainId: string | null;
  } | null;
};
export type deleteAutojoinDomainMutation = {
  variables: deleteAutojoinDomainMutation$variables;
  response: deleteAutojoinDomainMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteAutojoinDomainPayload",
    "kind": "LinkedField",
    "name": "deleteAutojoinDomain",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedAutojoinDomainId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteAutojoinDomainMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteAutojoinDomainMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "284b0865b717e816ba51b84a3df33b33",
    "id": null,
    "metadata": {},
    "name": "deleteAutojoinDomainMutation",
    "operationKind": "mutation",
    "text": "mutation deleteAutojoinDomainMutation(\n  $input: DeleteAutojoinDomainInput!\n) {\n  deleteAutojoinDomain(input: $input) {\n    deletedAutojoinDomainId\n  }\n}\n"
  }
};
})();

(node as any).hash = "23f60e8e9adb100a4aaea231227b0c96";

export default node;
